import { render, staticRenderFns } from "./GenerateReportCardSheet.vue?vue&type=template&id=548b65f5"
import script from "./GenerateReportCardSheet.vue?vue&type=script&lang=js"
export * from "./GenerateReportCardSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports